import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import isEmpty from 'lodash/isEmpty';
import { Title, PageHeader, LocationSelect } from '../Shared';
import { leaderboardActions, locationActions } from '../_actions';
import classnames from 'classnames';
import { LeaderBoardPane } from '../Locations';

function Leaderboards(props) {
  const { overviews, locations, getLocations, getOverviewLeaderboard } = props;
  const [locationId, setLocationId] = useState(0);
  const [infoTab, setInfoTab] = useState('casual');

  useEffect(() => {
    getLocations();
    getOverviewLeaderboard();
  }, [getLocations, getOverviewLeaderboard]);

  const handleChange = (e) => {
    setLocationId(parseFloat(e.target.value));
  };

  const lbData =
    overviews && locationId !== 0
      ? overviews.find((l) => l.id === locationId)
      : [];

  return (
    <Fragment>
      <Title text="Leaderboard" />
      <PageHeader className="default">
        <Row>
          <Col sm={12}>
            <h2 className="orange-title text-center">Leaderboards</h2>
          </Col>
        </Row>
      </PageHeader>

      <Container className="pl-4 pr-4">
        <Row>
          <Col>
            {locations && (
              <LocationSelect
                handleChange={handleChange}
                allLocations={locations}
              />
            )}
          </Col>
        </Row>
      </Container>

      {locationId === 0 && (
        <Container
          className="mt-4 pb-4 pl-4 pr-4"
          style={{ backgroundColor: '#fff' }}
        >
          <Nav className="rounded-tabs" fill tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: infoTab === 'casual' })}
                onClick={() => setInfoTab('casual')}
              >
                CASUAL TIMES
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: infoTab === 'event' })}
                onClick={() => setInfoTab('event')}
              >
                COMPETITION TIMES
              </NavLink>
            </NavItem>
          </Nav>
        </Container>
      )}

      {!isEmpty(lbData) && (
        <Container
          className="mt-4 pb-4 pl-4 pr-4"
          style={{ backgroundColor: '#fff' }}
        >
          <Nav className="rounded-tabs" fill tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: infoTab === 'casual' })}
                onClick={() => setInfoTab('casual')}
              >
                CASUAL TIMES
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: infoTab === 'event' })}
                onClick={() => setInfoTab('event')}
              >
                COMPETITION TIMES
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={infoTab}>
            <TabPane tabId="casual">
              <LeaderBoardPane data={lbData.unofficial} />
            </TabPane>
            <TabPane tabId="event">
              <LeaderBoardPane data={lbData.official} />
            </TabPane>
          </TabContent>
        </Container>
      )}
    </Fragment>
  );
}

function mapStateToProps(state) {
  const { overviews } = state.leaderboard;
  const { locations } = state.location;
  return { overviews, locations };
}

const mapDispatchToProps = {
  getLocations: locationActions.getAll,
  getOverviewLeaderboard: leaderboardActions.getOverviewLeaderboard,
};

const connectedLeaderboards = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Leaderboards);

export { connectedLeaderboards as Leaderboards };
